import { IOrderTaskUseCase, IOrder } from "@lib";
import { IOrderTaskCreateDto, IOrderTaskUpdateDto } from "@lib";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";

export class OrderTaskUseCase implements IOrderTaskUseCase {
    public async create(
        companyId: string,
        officeId: string,
        orderId: string,
        dto: IOrderTaskCreateDto,
    ): Promise<IOrder> {
        try {
            const response = await Api.post<IOrder>(
                `/companies/${companyId}/offices/${officeId}/orders/${orderId}/tasks`,
                dto,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async update(
        companyId: string,
        officeId: string,
        orderId: string,
        taskId: string,
        dto: IOrderTaskUpdateDto,
    ): Promise<IOrder> {
        try {
            const response = await Api.put<IOrder>(
                `/companies/${companyId}/offices/${officeId}/orders/${orderId}/tasks/${taskId}`,
                dto,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async move(
        companyId: string,
        officeId: string,
        orderId: string,
        taskId: string,
        newIndex: number,
    ): Promise<IOrder> {
        try {
            const response = await Api.patch<IOrder>(
                `/companies/${companyId}/offices/${officeId}/orders/${orderId}/tasks/${taskId}/move`,
                { newIndex },
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async delete(companyId: string, officeId: string, orderId: string, taskId: string): Promise<IOrder> {
        try {
            const response = await Api.delete<IOrder>(
                `/companies/${companyId}/offices/${officeId}/orders/${orderId}/tasks/${taskId}`,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
